import { render } from "./viewInfo.vue?vue&type=template&id=29ee2683&scoped=true"
import script from "./viewInfo.vue?vue&type=script&lang=js"
export * from "./viewInfo.vue?vue&type=script&lang=js"

import "./viewInfo.vue?vue&type=style&index=0&id=29ee2683&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ee2683"]])

export default __exports__